/**
 * The four-digit year of the current_film_festival flag (26 → 2026). Follows
 * the flag, including the debug bar's "Previous Year" switch.
 */
export const useFestivalYear = () => {
  const openFeature = useOpenFeature()
  return computed(() => 2000 + openFeature.getNumber('current_film_festival'))
}

/**
 * Seasonal roles are named per year (e.g. "2026 Selection Committee"); this
 * prefixes a role name with the current festival's year.
 */
export const useFestivalRole = (role: () => string | undefined) => {
  const year = useFestivalYear()
  return computed(() => {
    const name = role()
    return name ? `${year.value} ${name}` : undefined
  })
}
